import { useCallback } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { IconButton, PromoBanner } from "@similarweb/ui-components";
import { Box, Flex } from "@similarweb/ui-components/foundations";

import siNavigator from "app/pages/sales-intelligence/services/siNavigator";

import { useCrmIndustryTransitionState } from "../../hooks/useHasAnyPendingCrmIndustryTransition";
import { getFirstCrmWithPendingJobsTransition } from "../../utils/crmJobsTransition";
import { industryTransitionKeys } from "../../utils/i18n";

export const CrmJobsTransitionBanner = () => {
    const { translate } = useTranslate();
    const { hasPendingTransition, data } = useCrmIndustryTransitionState();

    const handleGoToCrmSettings = useCallback(() => {
        const crm = getFirstCrmWithPendingJobsTransition(data);

        if (!crm) {
            return;
        }

        void siNavigator.goToCrmManagementPage({ crm });
    }, [data]);

    if (!hasPendingTransition) {
        return null;
    }

    return (
        <Box
            data-automation="crm-jobs-transition-banner"
            width="100%"
        >
            <PromoBanner>
                <PromoBanner.Content>
                    <PromoBanner.Title data-automation="crm-jobs-transition-banner-title">
                        {translate(industryTransitionKeys.crmJobsBannerTitle)}
                    </PromoBanner.Title>

                    <PromoBanner.Description data-automation="crm-jobs-transition-banner-description">
                        {translate(industryTransitionKeys.crmJobsBannerDescription)}
                    </PromoBanner.Description>
                </PromoBanner.Content>

                <Flex flexShrink={0}>
                    <IconButton
                        type="primary"
                        buttonHtmlType="button"
                        iconName="arrow-right"
                        iconSize="12px"
                        placement="right"
                        onClick={handleGoToCrmSettings}
                        data-automation="crm-jobs-transition-banner-cta"
                    >
                        {translate(industryTransitionKeys.crmJobsBannerCta)}
                    </IconButton>
                </Flex>
            </PromoBanner>
        </Box>
    );
};
